import React, { useState, useContext, useEffect, useCallback, Fragment } from 'react'
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import DropdownButton from 'react-bootstrap/DropdownButton';
import Dropdown from 'react-bootstrap/Dropdown';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import TFDoughnut from '../../Charts/Doughnut';
import { DataGridPro, GridActionsCellItem, GridFooterContainer } from '@mui/x-data-grid-pro';
import { ObjModal } from '../../../contexts';
import SendTxt from '../../Modals/SendTxt';
import SendEmail from '../../Modals/SendEmail';
import EmailIcon from '@mui/icons-material/Email';
import TextsmsIcon from '@mui/icons-material/Textsms';
import { update } from '../../../common/api';
import { formatPhone } from '../../../common/utils';
import { toast } from 'react-toastify';
import Chip from '@mui/material/Chip';
import { singleSelectQuickFilter } from '../../../common/utils';

import '../../../containers/Dashboard/dashboard.css';


const QueueSegment = ( { orgId, aid, uid, user, viewing, stack, contacts, loans, chartTitle, chartSub, chartData, gridTitle, gridData, gridCols, gridActions } ) => {
    const [ selectedRows, setSelectedRows ] = useState( [] );
    const [ cols, setCols ] = useState( [] );
    const { openModal, closeModal, setModal } = useContext( ObjModal );
    const [ hasPhoneBurner, setHasPhoneBurner ] = useState( false );
    const [ hasTxting, setHasTxting ] = useState( false );
    const [ acctChips, setAcctChips ] = useState( {} );
    const [ showChip, setShowChip ] = useState( false );
    const [ gridReady, setGridReady ] = useState( false );

    const gridHelpers = {
        valueGetter: {
            date: ( { value } ) => {
                let d;
                if ( value ) {
                    d = new Date( value.match( 'T' ) ? value : value + 'T12:00:00' );
                }
                return ( d ) ? d : null;
            },
            opp: ( { row } ) => {
                let d;
                if ( row.lo && row.lo.oppDate ) {
                    d = new Date( row.lo.oppDate.match( 'T' ) ? row.lo.oppDate : row.lo.oppDate + 'T12:00:00' );
                }
                return ( d ) ? d : null;
            },
            referral: ( { row } ) => {
                let name;
                if ( row.borrowers ) {
                    const c = contacts[row.borrowers[0].cid];
                    if ( c && c.referredById ) {
                        const r = contacts[c.referredById];
                        if ( r ) {
                            name = r.name;
                        }
                    }
                } else if ( row.c ) {
                    if ( row.c.referredById ) {
                        const r = contacts[row.c.referredById];
                        if ( r ) {
                            name = r.name;
                        }
                    }
                }
                return ( name ) ? name : '';
            },
            lp1: ( { row } ) => {
                let name;
                if ( row.lid ) {
                    const l = loans[row.lid];
                    if ( l && l.lp1 ) {
                        name = l.lp1;
                    }
                }
                return name ? name : '';
            },
            lp2: ( { row } ) => {
                let name;
                if ( row.lid ) {
                    const l = loans[row.lid];
                    if ( l && l.lp2 ) {
                        name = l.lp2;
                    }
                }
                return name ? name : '';
            }
        },
        renderCell: {
            title: ( { row } ) => (
                <Row>
                    <Col className='py-2'>
                        <Row className='align-items-center'>
                            <Col>
                                <span  style={ { fontWeight: 500, fontSize: '14px' } }>
                                {
                                    ( row.lid ) ? (
                                        <Fragment>
                                            <Link to={`/loan/${row.lid}`}>{row.title}</Link>
                                            {
                                                ( showChip && aid !== row.aid ) ? (
                                                    <Chip label={acctChips[row.aid]} variant='outlined' size='small' className='ms-2' />
                                                ) : (
                                                    null
                                                )
                                            }
                                        </Fragment>
                                    ) : (
                                        <Link to={`/contact/${row.c.cid}`}>{row.title}</Link>
                                    ) 
                                }
                                </span>
                            </Col>
                        </Row>
                        {
                            ( row.c && row.c.namePartner1 ) ? (
                                <Row><Col style={ { fontSize: '11px' } }>Partner: {row.c.namePartner1}</Col></Row>
                            ) : ( row.c && row.c.firstnamePartner1 ) ? (
                                <Row><Col style={ { fontSize: '11px' } }>Partner: {`${row.c.firstnamePartner1} ${row.c.lastnamePartner1}`}</Col></Row>
                            ) : (
                                null
                            )
                        }
                    </Col>
                </Row>
            ),
            date: ( { value } ) => {
                let d;
                if ( value ) {
                    d = value.toLocaleDateString();
                }
                return d;
            },
            referral: ( { row } ) => {
                if ( row.borrowers ) {
                    const c = contacts[row.borrowers[0].cid];
                    if ( c && c.referredById ) {
                        const r = contacts[c.referredById];
                        if ( r ) {
                            return <Link to={`/contact/${r.cid}`}>{r.name}</Link>
                        }
                    }
                } else if ( row.c ) {
                    if ( row.c.referredById ) {
                        const r = contacts[row.c.referredById];
                        if ( r ) {
                            return <Link to={`/contact/${r.cid}`}>{r.name}</Link>
                        }
                    }
                }
                return null;
            },
            html: ( { value } ) => {
                return <div style={ { paddingLeft: '20px' } } dangerouslySetInnerHTML={ { __html: value } } />
            }
        },
        valueFormatter: {
            date: ( { value } ) => {
                return ( value ) ? value.toLocaleDateString() : null;
            }
        },
        getApplyQuickFilterFn: {
            singleSelectQuickFilter: singleSelectQuickFilter
        }
    };

    const handleAction = useCallback( async ( at, lid ) => {
        let updated;

        switch ( at ) {
            case 'more-docs':
                console.log( 'updating more docs: ' + lid );
                updated = await update( orgId, aid, uid, 'loan', lid, { setupResults: 'More Information Requested', setupMissingDocsDate: new Date().toJSON() } );
                if ( updated.length ) {
                    toast.success( `The loan has been marked as needing more info - nice work!`, { theme: 'dark' } );
                }
                break;

            case 'ready-review':
                console.log( 'updating ready review: ' + lid );
                updated = await update( orgId, aid, uid, 'loan', lid, { status: 'PA Review', stage: 'Ready for Review' } );
                if ( updated.length ) {
                    toast.success( `The loan has been marked for PA Review - nice work!`, { theme: 'dark' } );
                }
                break;
    
            default:
                console.log( 'Unknown action type: ' + at );
        }
    }, [ aid, uid, orgId ] );

    const handleSingleModal = useCallback( async ( t, cid, oid, tmpl, defaultContact ) => {
        let shouldOpen = true;
        let isAction = false;
        console.log( 'handling single modal: ', t, cid, oid, tmpl, defaultContact );
        console.log( contacts[cid] );

        switch ( t ) {
            case 'email':
                setModal( <SendEmail close={closeModal} tmpl={tmpl} obj={contacts[cid]} objType='contact' /> ); 
                break;

            case 'sms':
                setModal( <SendTxt close={closeModal} tmpl={tmpl} obj={contacts[cid]} objType='contact' defaultContact={defaultContact} /> );
                break;
                
            case 'more-docs':
            case 'ready-review':
                console.log( 'flagging action: ' + t );
                isAction = true;
                break;

            default:
                shouldOpen = false;
                console.log( 'unknown modeal type for single: ' + t + ' - ' + cid )  ;
        }

        if ( isAction ) {
            await handleAction( t, oid )
        } else if ( shouldOpen ) {
            openModal();
        }

    }, [ openModal, closeModal, setModal, handleAction, contacts ] );

    const handleMassModal = ( t ) => {
        let shouldOpen = true;

        let contacts = [];
        selectedRows.forEach( r => {
            console.log( r );
            // const [ loid, cid ] = r.split( '#' );
            // contacts.push( leads.find( f => f.cid === cid ) );
        } );

        switch ( t ) {
            case 'email-mass':
                // setModal( <SendMassEmail contacts={ contacts } close={ closeModal } /> ); 
                break;

            case 'sms-mass':
                setModal( <SendTxt contacts={ contacts } close={ closeModal } /> ); 
                break;
    
            case 'phoneburner':
                setModal( <div>phoneburner</div> ); 
                break;
        
            default:
                console.log( 'Unknown modal type: ' + t );
                shouldOpen = false;
        }

        if ( shouldOpen ) {
            openModal();
        }
    }

    const CustomFooter = () => {
        return (
            <GridFooterContainer>
                <Container>
                    <Row className='align-items-center'>
                        <Col>
                            {
                                ( selectedRows.length > 0 ) ? (
                                    <Row style={ { borderLeft: '1px solid #CCC' } }>
                                        <Col xs='auto' className='pe-2'>Take Action...</Col>
                                        <Col xs='auto' className='ps-0'>
                                            <DropdownButton size='sm' title={<KeyboardArrowDownIcon />} className='tf-button-transparent tf-hide-arrow'>
                                                <Dropdown.Item onClick={ () => handleMassModal( 'email-mass' ) }>Send Email</Dropdown.Item>
                                                <Dropdown.Item onClick={ () => handleMassModal( 'sms-mass' ) }>Send Txt</Dropdown.Item>
                                                {
                                                    hasPhoneBurner ? (
                                                        <Dropdown.Item onClick={ () => handleMassModal( 'phoneburner' ) }>Launch PhoneBurner</Dropdown.Item>
                                                    ) : (
                                                        null
                                                    )
                                                }
                                            </DropdownButton>
                                        </Col>
                                    </Row>
                                ) : (
                                    null
                                )
                            }
                        </Col>
                        <Col className='text-end'>
                            Total: {gridData.length}
                        </Col>
                    </Row>
                </Container>
            </GridFooterContainer>
        );
    };

    useEffect( () => {
        if ( user.additionalAccounts && user.additionalAccounts.length ) {
            const list = {};
            user.additionalAccounts.forEach( f => list[f.aid] = f.label );

            setShowChip( viewing.length > 1 );
            setAcctChips( list );
        }
    }, [ user.additionalAccounts, viewing ] );

    useEffect( () => {
        const iconMap = {
            email: <EmailIcon />,
            sms: <TextsmsIcon />
        };
        
        if ( gridCols && gridCols.length && !gridReady ) {
            let storedCols = JSON.parse( gridCols );
            if ( storedCols ) {
                let cols = storedCols.map( c => {
                    if ( c.headerName.match( /^var:/ ) ) {
                        const param = c.headerName.split( ':' )[1];
                        c.headerName = eval( param ); 
                    }
                    if ( c.renderCell && gridHelpers.renderCell[c.renderCell] ) {
                        c.renderCell = gridHelpers.renderCell[c.renderCell];
                    }
                    if ( c.valueGetter && gridHelpers.valueGetter[c.valueGetter] ) {
                        c.valueGetter = gridHelpers.valueGetter[c.valueGetter];
                    }
                    if ( c.valueFormatter && gridHelpers.valueFormatter[c.valueFormatter] ) {
                        c.valueFormatter = gridHelpers.valueFormatter[c.valueFormatter];
                    }
                    if ( c.getApplyQuickFilterFn && gridHelpers.getApplyQuickFilterFn[c.getApplyQuickFilterFn] ) {
                        c.getApplyQuickFilterFn = gridHelpers.getApplyQuickFilterFn[c.getApplyQuickFilterFn];
                    }

                    return c;
                } );

                if ( gridActions && gridActions.length ) {
                    const storedActions = JSON.parse( gridActions );
                    const actions = storedActions.map( a => {
                        if ( a.icon ) {
                            a.icon = iconMap[a.icon];
                        }
                        return a;
                    } );
                    if ( actions.length ) {
                        cols.push( { field: 'actions', type: 'actions', width: 100, getActions: ( { row } ) => actions.map( ( a, idx ) =>  <GridActionsCellItem icon={ a.icon } onClick={ () => handleSingleModal( a.type, row.c.cid, row.lid, a.tmpl, a.defaultContact ) } label={a.label} showInMenu={a.dropdown} /> ) } );
                    }
                }
                setCols( cols );
                setGridReady( true );
            }
        }
        // switch ( gridTitle ) {
        //     case 'Loan App Started':
        //         cs = [
        //             { field: 'title', headerName: gridTitle, width: 200, renderCell: ( { row } ) => (
        //               <Row>
        //                 <Col className='py-2'>
        //                   <Row className='align-items-center'>
        //                       <Col>
        //                           <span  style={ { fontWeight: 500, fontSize: '14px' } }>
        //                               { ( row.lid ) ? (
        //                                     <Fragment>
        //                                         <Link to={`/loan/${row.lid}`}>{row.title}</Link>
        //                                         {
        //                                             ( showChip && aid !== row.aid ) ? (
        //                                                 <Chip label={acctChips[row.aid]} variant='outlined' size='small' className='ms-2' />
        //                                             ) : (
        //                                                 null
        //                                             )
        //                                         }
        //                                     </Fragment>
        //                               ) : (
        //                                   <Link to={`/contact/${row.c.cid}`}>{row.title}</Link>
        //                               ) }
        //                           </span>
        //                       </Col>
        //                   </Row>
        //                     {
        //                         ( row.c && row.c.namePartner1 ) ? (
        //                             <Row><Col style={ { fontSize: '11px' } }>Partner: {row.c.namePartner1}</Col></Row>
        //                         ) : ( row.c && row.c.firstnamePartner1 ) ? (
        //                             <Row><Col style={ { fontSize: '11px' } }>Partner: {`${row.c.firstnamePartner1} ${row.c.lastnamePartner1}`}</Col></Row>
        //                         ) : (
        //                             null
        //                         )
        //                     }
        //                 </Col>
        //               </Row>
        //             ) },
        //             { field: 'ref', headerName: 'Referred By', width: 200, renderCell: ( { row } ) => {
        //                 if ( row.c && row.c.referredById ) {
        //                     return ( contacts[row.c.referredById] ) ? contacts[row.c.referredById].name : null;
        //                 }
        //                 return '';
        //             } },
        //             { field: 'date', headerName: 'App Started On', type: 'date', width: 125, valueGetter: ( { row } ) => {
        //                 let d;
        //                 const l = loans[row.lid];
        //                 if ( l && l.appStartedDate ) {
        //                     d = new Date( l.appStartedDate );
        //                     if ( d ) {
        //                         d.setDate( d.getDate() + 1 );
        //                     }
        //                 }
        //                 return ( d ) ? d : null;
        //             } }
        //         ];
        //         actions = [
        //             { icon: <TextsmsIcon />, label: 'Txt - Client', type: 'sms', tmpl: 'tmpl_app-started-client-v1', defaultContact: 'contact', dropdown: true },
        //             { icon: <EmailIcon />, label: 'Email - Client', type: 'email', tmpl: 'tmpl_app-started-client-v1', dropdown: true },
        //             { icon: <TextsmsIcon />, label: 'Txt - Referral Partner', type: 'sms', tmpl: 'tmpl_app-started-referral-v1', defaultContact: 'referredBy', dropdown: true },
        //             { icon: <EmailIcon />, label: 'Email - Referral Partner', type: 'email', tmpl: 'tmpl_app-started-referral-v1', dropdown: true }
        //         ];
        //         break;

        //         case 'App Completed':
        //             cs = [
        //                 { field: 'title', headerName: gridTitle, width: 200, renderCell: ( { row } ) => (
        //                   <Row>
        //                     <Col className='py-2'>
        //                       <Row className='align-items-center'>
        //                           <Col>
        //                               <span  style={ { fontWeight: 500, fontSize: '14px' } }>
        //                                   { ( row.lid ) ? (
        //                                         <Fragment>
        //                                             <Link to={`/loan/${row.lid}`}>{row.title}</Link>
        //                                             {
        //                                                 ( showChip && aid !== row.aid ) ? (
        //                                                     <Chip label={acctChips[row.aid]} variant='outlined' size='small' className='ms-2' />
        //                                                 ) : (
        //                                                     null
        //                                                 )
        //                                             }
        //                                         </Fragment>
        //                                   ) : (
        //                                       <Link to={`/contact/${row.c.cid}`}>{row.title}</Link>
        //                                   ) }
        //                               </span>
        //                           </Col>
        //                       </Row>
        //                       {
        //                         ( row.c && row.c.namePartner1 ) ? (
        //                             <Row><Col style={ { fontSize: '11px' } }>Partner: {row.c.namePartner1}</Col></Row>
        //                         ) : ( row.c && row.c.firstnamePartner1 ) ? (
        //                             <Row><Col style={ { fontSize: '11px' } }>Partner: {`${row.c.firstnamePartner1} ${row.c.lastnamePartner1}`}</Col></Row>
        //                         ) : (
        //                             null
        //                         )
        //                       }
        //                     </Col>
        //                   </Row>
        //                 ) },
        //                 { field: 'ref', headerName: 'Referred By', width: 200, renderCell: ( { row } ) => {
        //                     if ( row.c && row.c.referredById ) {
        //                         return ( contacts[row.c.referredById] ) ? contacts[row.c.referredById].name : null;
        //                     }
        //                     return '';
        //                 } },
        //                 { field: 'date', headerName: 'App Completed On', type: 'date', width: 125, valueGetter: ( { row } ) => {
        //                     let d;
        //                     const l = loans[row.lid];
        //                     if ( l && l.appCompletedDate ) {
        //                         d = new Date( l.appCompletedDate );
        //                         if ( d ) {
        //                             d.setDate( d.getDate() + 1 );
        //                         }
        //                     }
        //                     return ( d ) ? d : null;
        //                 } }
        //             ];
        //             actions = [
        //                 { icon: <TextsmsIcon />, label: 'Txt - Client', type: 'sms', tmpl: 'tmpl_app-completed-client-v1', defaultContact: 'contact', dropdown: true },
        //                 { icon: <EmailIcon />, label: 'Email - Client', type: 'email', tmpl: 'tmpl_app-completed-client-v1', dropdown: true },
        //                 { icon: <TextsmsIcon />, label: 'Txt - Referral Partner', type: 'sms', tmpl: 'tmpl_app-completed-referral-v1', defaultContact: 'referredBy', dropdown: true },
        //                 { icon: <EmailIcon />, label: 'Email - Referral Partner', type: 'email', tmpl: 'tmpl_app-completed-referral-v1', dropdown: true }
        //             ];
        //             break;

        //         case 'Ready for Setup':
        //             cs = [
        //                 { field: 'title', headerName: gridTitle, width: 200, renderCell: ( { row } ) => (
        //                   <Row>
        //                     <Col className='py-2'>
        //                       <Row className='align-items-center'>
        //                           <Col>
        //                               <span  style={ { fontWeight: 500, fontSize: '14px' } }>
        //                                   { ( row.lid ) ? (
        //                                         <Fragment>
        //                                             <Link to={`/loan/${row.lid}`}>{row.title}</Link>
        //                                             {
        //                                                 ( showChip && aid !== row.aid ) ? (
        //                                                     <Chip label={acctChips[row.aid]} variant='outlined' size='small' className='ms-2' />
        //                                                 ) : (
        //                                                     null
        //                                                 )
        //                                             }
        //                                         </Fragment>
        //                                   ) : (
        //                                       <Link to={`/contact/${row.c.cid}`}>{row.title}</Link>
        //                                   ) }
        //                               </span>
        //                           </Col>
        //                       </Row>
        //                       {
        //                         ( row.c && row.c.namePartner1 ) ? (
        //                             <Row><Col style={ { fontSize: '11px' } }>Partner: {row.c.namePartner1}</Col></Row>
        //                         ) : ( row.c && row.c.firstnamePartner1 ) ? (
        //                             <Row><Col style={ { fontSize: '11px' } }>Partner: {`${row.c.firstnamePartner1} ${row.c.lastnamePartner1}`}</Col></Row>
        //                         ) : (
        //                             null
        //                         )
        //                       }
        //                     </Col>
        //                   </Row>
        //                 ) },
        //                 { field: 'ref', headerName: 'Referred By', width: 200, renderCell: ( { row } ) => {
        //                     if ( row.c && row.c.referredById ) {
        //                         return ( contacts[row.c.referredById] ) ? contacts[row.c.referredById].name : null;
        //                     }
        //                     return '';
        //                 } },
        //                 { field: 'date', headerName: 'Docs Last Uploaded', type: 'date', width: 125, valueGetter: ( { row } ) => {
        //                     let d;
        //                     const l = loans[row.lid];
        //                     if ( l && l.appDocsUploadedDate ) {
        //                         d = new Date( l.appDocsUploadedDate );
        //                         if ( d ) {
        //                             d.setDate( d.getDate() + 1 );
        //                         }
        //                     }
        //                     return ( d ) ? d : null;
        //                 } },
        //                 { field: 'lp1', headerName: 'LP1', width: 200, renderCell: ( { row } ) => {
        //                     if ( loans[row.lid].lp1 ) {
        //                         return loans[row.lid].lp1;
        //                     }
        //                     return '';
        //                 } }
        //             ];
        //             actions = [
        //                 { icon: <TextsmsIcon />, label: 'Txt - Client', type: 'sms', defaultContact: 'contact', dropdown: true },
        //                 { icon: <EmailIcon />, label: 'Email - Client', type: 'email', dropdown: true },
        //                 { icon: <TextsmsIcon />, label: 'Txt - Referral Partner', type: 'sms', defaultContact: 'referredBy', dropdown: true },
        //                 { icon: <EmailIcon />, label: 'Email - Referral Partner', type: 'email', dropdown: true },
        //                 { label: 'Needs More Docs', type: 'more-docs', dropdown: true },
        //                 { label: 'Ready for Review', type: 'ready-review', dropdown: true }
        //             ];
        //             break;

        //         case 'Need More Docs':
        //             cs = [
        //                 { field: 'title', headerName: gridTitle, width: 200, renderCell: ( { row } ) => (
        //                   <Row>
        //                     <Col className='py-2'>
        //                       <Row className='align-items-center'>
        //                           <Col>
        //                               <span  style={ { fontWeight: 500, fontSize: '14px' } }>
        //                                   { ( row.lid ) ? (
        //                                         <Fragment>
        //                                             <Link to={`/loan/${row.lid}`}>{row.title}</Link>
        //                                             {
        //                                                 ( showChip && aid !== row.aid ) ? (
        //                                                     <Chip label={acctChips[row.aid]} variant='outlined' size='small' className='ms-2' />
        //                                                 ) : (
        //                                                     null
        //                                                 )
        //                                             }
        //                                         </Fragment>
        //                                   ) : (
        //                                       <Link to={`/contact/${row.c.cid}`}>{row.title}</Link>
        //                                   ) }
        //                               </span>
        //                           </Col>
        //                       </Row>
        //                       {
        //                         ( row.c && row.c.namePartner1 ) ? (
        //                             <Row><Col style={ { fontSize: '11px' } }>Partner: {row.c.namePartner1}</Col></Row>
        //                         ) : ( row.c && row.c.firstnamePartner1 ) ? (
        //                             <Row><Col style={ { fontSize: '11px' } }>Partner: {`${row.c.firstnamePartner1} ${row.c.lastnamePartner1}`}</Col></Row>
        //                         ) : (
        //                             null
        //                         )
        //                       }
        //                     </Col>
        //                   </Row>
        //                 ) },
        //                 { field: 'ref', headerName: 'Referred By', width: 200, valueGetter: ( { row } ) => {
        //                     if ( row.c && row.c.referredById ) {
        //                         return ( contacts[row.c.referredById] ) ? contacts[row.c.referredById].name : null;
        //                     }
        //                     return '';
        //                 } },
        //                 { field: 'date', headerName: 'Docs Last Uploaded', type: 'date', width: 125, valueGetter: ( { row } ) => {
        //                     let d;
        //                     const l = loans[row.lid];
        //                     if ( l && l.appDocsUploadedDate ) {
        //                         d = new Date( l.appDocsUploadedDate );
        //                         if ( d ) {
        //                             d.setDate( d.getDate() + 1 );
        //                         }
        //                     }
        //                     return ( d ) ? d : null;
        //                 } },
        //                 { field: 'setupMissingDocsDate', headerName: 'List Sent', type: 'date', width: 125, valueGetter: ( { row } ) => {
        //                     let d;
        //                     const l = loans[row.lid];
        //                     if ( l && l.setupMissingDocsDate ) {
        //                         d = new Date( l.setupMissingDocsDate );
        //                         if ( d ) {
        //                             d.setDate( d.getDate() + 1 );
        //                         }
        //                     }
        //                     return ( d ) ? d : null;
        //                 } },
        //                 { field: 'setupMissingDocs', headerName: 'Missing Docs', width: 300, valueGetter: ( { row } ) => {
        //                     if ( loans[row.lid].setupMissingDocs ) {
        //                         return loans[row.lid].setupMissingDocs;
        //                     }
        //                     return '';
        //                 }, renderCell: ( { value } ) => {
        //                     return <div style={ { paddingLeft: '20px' } } dangerouslySetInnerHTML={ { __html: value } } />
        //                 } }
        //             ];
        //             break;

        //         case 'Ready for Review':
        //             cs = [
        //                 { field: 'title', headerName: gridTitle, width: 200, renderCell: ( { row } ) => (
        //                   <Row>
        //                     <Col className='py-2'>
        //                       <Row className='align-items-center'>
        //                           <Col>
        //                               <span  style={ { fontWeight: 500, fontSize: '14px' } }>
        //                                   { ( row.lid ) ? (
        //                                         <Fragment>
        //                                             <Link to={`/loan/${row.lid}`}>{row.title}</Link>
        //                                             {
        //                                                 ( showChip && aid !== row.aid ) ? (
        //                                                     <Chip label={acctChips[row.aid]} variant='outlined' size='small' className='ms-2' />
        //                                                 ) : (
        //                                                     null
        //                                                 )
        //                                             }
        //                                         </Fragment>
        //                                   ) : (
        //                                       <Link to={`/contact/${row.c.cid}`}>{row.title}</Link>
        //                                   ) }
        //                               </span>
        //                           </Col>
        //                       </Row>
        //                       {
        //                         ( row.c && row.c.namePartner1 ) ? (
        //                             <Row><Col style={ { fontSize: '11px' } }>Partner: {row.c.namePartner1}</Col></Row>
        //                         ) : ( row.c && row.c.firstnamePartner1 ) ? (
        //                             <Row><Col style={ { fontSize: '11px' } }>Partner: {`${row.c.firstnamePartner1} ${row.c.lastnamePartner1}`}</Col></Row>
        //                         ) : (
        //                             null
        //                         )
        //                       }
        //                     </Col>
        //                   </Row>
        //                 ) },
        //                 { field: 'due', headerName: 'Complete By', type: 'date', width: 100, valueGetter: ( { row } ) => {
        //                     let d;
        //                     if ( row.due ) {
        //                         d = new Date( row.due );
        //                     }
        //                     return ( d ) ? d : null;
        //                 } },
        //                 { field: 'ref', headerName: 'Referred By', width: 200, renderCell: ( { row } ) => {
        //                     if ( row.c && row.c.referredById ) {
        //                         return ( contacts[row.c.referredById] ) ? contacts[row.c.referredById].name : null;
        //                     }
        //                     return '';
        //                 } },
        //                 { field: 'date', headerName: 'Setup Completed On', type: 'date', width: 125, valueGetter: ( { row } ) => {
        //                     let d;
        //                     const l = loans[row.lid];
        //                     if ( l && l.setupCompletedDate ) {
        //                         d = new Date( l.setupCompletedDate );
        //                         if ( d ) {
        //                             d.setDate( d.getDate() + 1 );
        //                         }
        //                     }
        //                     return ( d ) ? d : null;
        //                 } }
        //             ];
        //             break;

        //         case 'Ready for TBD':
        //         case 'Ready for FT':
        //             cs = [
        //                 { field: 'title', headerName: gridTitle, width: 200, renderCell: ( { row } ) => (
        //                   <Row>
        //                     <Col className='py-2'>
        //                       <Row className='align-items-center'>
        //                           <Col>
        //                               <span  style={ { fontWeight: 500, fontSize: '14px' } }>
        //                                   { ( row.lid ) ? (
        //                                         <Fragment>
        //                                             <Link to={`/loan/${row.lid}`}>{row.title}</Link>
        //                                             {
        //                                                 ( showChip && aid !== row.aid ) ? (
        //                                                     <Chip label={acctChips[row.aid]} variant='outlined' size='small' className='ms-2' />
        //                                                 ) : (
        //                                                     null
        //                                                 )
        //                                             }
        //                                         </Fragment>
        //                                   ) : (
        //                                       <Link to={`/contact/${row.c.cid}`}>{row.title}</Link>
        //                                   ) }
        //                               </span>
        //                           </Col>
        //                       </Row>
        //                       {
        //                         ( row.c && row.c.namePartner1 ) ? (
        //                             <Row><Col style={ { fontSize: '11px' } }>Partner: {row.c.namePartner1}</Col></Row>
        //                         ) : ( row.c && row.c.firstnamePartner1 ) ? (
        //                             <Row><Col style={ { fontSize: '11px' } }>Partner: {`${row.c.firstnamePartner1} ${row.c.lastnamePartner1}`}</Col></Row>
        //                         ) : (
        //                             null
        //                         )
        //                       }
        //                     </Col>
        //                   </Row>
        //                 ) },
        //                 { field: 'ref', headerName: 'Referred By', width: 200, renderCell: ( { row } ) => {
        //                     if ( row.c && row.c.referredById ) {
        //                         return ( contacts[row.c.referredById] ) ? contacts[row.c.referredById].name : null;
        //                     }
        //                     return '';
        //                 } },
        //                 { field: 'date', headerName: 'Reviewed On', type: 'date', width: 125, valueGetter: ( { row } ) => {
        //                     let d;
        //                     const l = loans[row.lid];
        //                     if ( l && l.paReviewedDate ) {
        //                         d = new Date( l.paReviewedDate );
        //                         if ( d ) {
        //                             d.setDate( d.getDate() + 1 );
        //                         }
        //                     }
        //                     return ( d ) ? d : null;
        //                 } },
        //                 { field: 'lp2', headerName: 'LP2', width: 200, renderCell: ( { row } ) => {
        //                     if ( loans[row.lid].lp2 ) {
        //                         return loans[row.lid].lp2;
        //                     }
        //                     return '';
        //                 } }
        //             ];
        //             break;

        //         case 'Fast Track Submitted':
        //             cs = [
        //                 { field: 'title', headerName: gridTitle, width: 200, renderCell: ( { row } ) => (
        //                   <Row>
        //                     <Col className='py-2'>
        //                       <Row className='align-items-center'>
        //                           <Col>
        //                               <span  style={ { fontWeight: 500, fontSize: '14px' } }>
        //                                   { ( row.lid ) ? (
        //                                         <Fragment>
        //                                             <Link to={`/loan/${row.lid}`}>{row.title}</Link>
        //                                             {
        //                                                 ( showChip && aid !== row.aid ) ? (
        //                                                     <Chip label={acctChips[row.aid]} variant='outlined' size='small' className='ms-2' />
        //                                                 ) : (
        //                                                     null
        //                                                 )
        //                                             }
        //                                         </Fragment>
        //                                   ) : (
        //                                       <Link to={`/contact/${row.c.cid}`}>{row.title}</Link>
        //                                   ) }
        //                               </span>
        //                           </Col>
        //                       </Row>
        //                       {
        //                         ( row.c && row.c.namePartner1 ) ? (
        //                             <Row><Col style={ { fontSize: '11px' } }>Partner: {row.c.namePartner1}</Col></Row>
        //                         ) : ( row.c && row.c.firstnamePartner1 ) ? (
        //                             <Row><Col style={ { fontSize: '11px' } }>Partner: {`${row.c.firstnamePartner1} ${row.c.lastnamePartner1}`}</Col></Row>
        //                         ) : (
        //                             null
        //                         )
        //                       }
        //                     </Col>
        //                   </Row>
        //                 ) },
        //                 { field: 'ref', headerName: 'Referred By', width: 200, renderCell: ( { row } ) => {
        //                     if ( row.c && row.c.referredById ) {
        //                         return ( contacts[row.c.referredById] ) ? contacts[row.c.referredById].name : null;
        //                     }
        //                     return '';
        //                 } },
        //                 { field: 'date', headerName: 'Reviewed On', type: 'date', width: 125, valueGetter: ( { row } ) => {
        //                     let d;
        //                     const l = loans[row.lid];
        //                     if ( l && l.paReviewedDate ) {
        //                         d = new Date( l.paReviewedDate );
        //                         if ( d ) {
        //                             d.setDate( d.getDate() + 1 );
        //                         }
        //                     }
        //                     return ( d ) ? d : null;
        //                 } },
        //                 { field: 'lp2', headerName: 'LP2', width: 200, renderCell: ( { row } ) => {
        //                     const l = loans[row.lid];
        //                     if ( l && l.lp2 ) {
        //                         return l.lp2;
        //                     }
        //                     return '';
        //                 } }
        //             ];
        //             break;

        //         default:
        //             console.log( 'unknown paprogress queue: ' + gridTitle );
        // }

        // if ( actions?.length ) {
        //     cs.push( { field: 'actions', type: 'actions', width: 100, getActions: ( { row } ) => actions.map( ( a, idx ) =>  <GridActionsCellItem icon={ a.icon } onClick={ () => handleSingleModal( a.type, row.c.cid, row.lid, a.tmpl, a.defaultContact ) } label={a.label} showInMenu={a.dropdown} /> ) } );
        // }

        // setCols( cs );
    }, [ gridTitle, contacts, loans, handleSingleModal, acctChips, showChip, aid, gridCols, gridActions, gridHelpers.renderCell, gridHelpers.valueGetter, gridHelpers.valueFormatter, gridHelpers.getApplyQuickFilterFn, gridReady ] );

    useEffect( () => {
        if ( stack ) {
            if ( stack.dialer && stack.dialer.type === 'PhoneBurner' ) {
                setHasPhoneBurner( true );
            }
            if ( stack.sms && stack.sms ) {
                setHasTxting( true );
            }
        }
    }, [ stack ] );

    return (
        <Container fluid className='p-0 tf-pasegment-container'>
            <Row className='p-0'>
                <Col>
                    <Row className='text-center py-3 mx-2'>
                        <Col>
                            <Row className='px-3'>
                                <Col className='w-100'>
                                    <TFDoughnut data={chartData} h='150px' title={chartTitle} sub={chartSub} />
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                    <Row className='mx-2'>
                        <Col>
                            <Row className='tf-dashboard-li-container overflow-auto pb-2'>
                                <Col style={ { height: '300px' } }>
                                {
                                    ( gridReady ) ? (
                                        <DataGridPro
                                            rows={gridData}
                                            columns={cols}
                                            disableSelectionOnClick
                                            slots={ { 
                                                footer: CustomFooter,
                                                moreActionsIcon: KeyboardArrowDownIcon
                                            } }
                                            onRowSelectionModelChange={ ( ids ) => setSelectedRows( ids ) }
                                            getRowHeight={ () => 'auto' }
                                            getRowClassName={ ( params ) => {
                                                if ( params.row.priority.match( /high/i ) ) {
                                                    return 'tf-gp-grid-high-priority-row';
                                                }
                                                return '';
                                            } }
                                        />
                                    ) : (
                                        null
                                    )
                                }
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                </Col>
            </Row>
        </Container>
    )
}

const mapProps = ( state ) => ( {
    orgId: state.user.orgId,
    aid: state.user.aid,
    uid: state.user.email,
    user: state.user,
    viewing: state.user.viewing,
    stack: state.user.stack,
    contacts: state.contacts.byId,
    loans: state.loans.byId
} );
  
const mapDispatch = ( dispatch ) => ( {
} );
  
export default connect( mapProps, mapDispatch )( QueueSegment );